import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=45a9725d&scoped=true"
import script from "./EventHeader.vue?vue&type=script&lang=js"
export * from "./EventHeader.vue?vue&type=script&lang=js"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=45a9725d&prod&lang=scss&scoped=true"
import style1 from "./EventHeader.vue?vue&type=style&index=1&id=45a9725d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a9725d",
  null
  
)

export default component.exports